import React, { useState } from 'react';
import "../Components/UserSignIn/ForgotPassword.css";
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Handle password reset logic here

    axios
      .post('/api/v1/users/password/forgot', { email: email })
      .then((response) => {
        setMessage(response.data.message);
        console.log(response.data);
        console.log(response.request);
      })
      .catch(function (error) {
        if (error.response) {
          //request made and server rejected it
          setMessage(`${error.response.status}: ${error.response.data.message}`);
          console.log(error.response.status);
          console.log(error.response.data);
          console.log(error.response.headers);
        } else if (error.request){
          //request made but no response received
          setMessage("No response from server");
        } else {
          //some other problem while setting up the request
          setMessage("Error setting up request");
        }
      });
    // console.log('Password reset request submitted for:', email);
  };

  return (
    <div className="forgot-password">
      <h1>Reset Your Password</h1>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={email}
            onChange={handleChange}
          />
        </div>

        {message && <div className="message">{message}</div>}  {/* Display message */}

        <button className="reset-button" type="submit">Reset Password</button>
      </form>
    </div>
  );
};

export default ForgotPassword;
